const application = {
  // HeroSection
  'application.hero.homeLink': 'Home',
  'application.hero.admissionLink': 'Admission Guide',
  'application.hero.currentPage': 'Eligibility & Application Process',
  'application.hero.imgAlt': 'An elegant still life of application documents and a fountain pen',

  // breadcrumb
  'application.breadcrumb.home': 'Home',
  'application.breadcrumb.admission': 'Admission Guide',
  'application.breadcrumb.current': 'Eligibility & Application Process',

  // Requirements
  'application.requirements.label': 'REQUIREMENTS',
  'application.requirements.title': 'What Are the Eligibility Requirements?',
  'application.requirements.titleEn': 'Eligibility & Application',
  'application.requirements.lead': 'Japan Butler Academy welcomes all who are eager to learn. With the exception of a minimum age requirement, no prior experience or specific background is necessary.',

  // DressCode
  'application.dress.label': 'DRESS CODE',
  'application.dress.imgCaption': 'White shirt, black trousers, leather shoes, and white gloves — the butler\'s standard attire.',

  // ApplicationSteps
  'application.steps.label': 'APPLICATION STEPS',
  'application.steps.title': 'Step-by-Step Application Process',
  'application.steps.titleEn': 'From Inquiry to Enrollment',
  'application.steps.lead': 'Here is a step-by-step guide from application to enrolment confirmation. We will be with you at every step to make sure you never feel lost.',
  'application.steps.optionalBadge': 'Optional',
  'application.steps.requiredBadge': 'Required',
  'application.steps.applyLink': 'Go to Application Form',

  // DeadlineInfo
  'application.deadline.label': 'DEADLINES',
  'application.deadline.contactNote': 'For full course start dates, please see the',
  'application.deadline.contactLink': 'Annual Schedule',
  'application.deadline.contactSuffix': '.',

  // PaymentInfo
  'application.payment.label': 'PAYMENT',
  'application.payment.bankOnlyNote': 'Instalment plans and credit card payments are not accepted. Payment is by bank transfer (lump-sum) only. Please note this before applying.',

  // FAQSection
  'application.faq.label': 'FAQ',
  'application.faq.title': 'Frequently Asked Questions',
  'application.faq.titleEn': 'Frequently Asked Questions',
  'application.faq.contactNote': 'For further enquiries, please use our',
  'application.faq.contactLink': 'contact form',
  'application.faq.contactSuffix': '.',

  // CTASection
  'application.cta.label': 'READY TO APPLY',
  'application.cta.title': 'Ready to Apply?',
  'application.cta.lead': 'Once you have reviewed the eligibility requirements and have no outstanding questions, please proceed to the application form. If you have any concerns, an individual consultation is always available.',
  'application.cta.onlineNote': '* Online consultations are also available.',
  'application.cta.applyBtn': 'Go to Application Form',
  'application.cta.consultBtn': 'Book a Free Consultation',
  'application.cta.brochureBtn': 'Request a Brochure (Free)',

  // RelatedPages
  'application.related.label': 'LEARN MORE',
  'application.related.title': 'Related Pages',
  'application.related.titleEn': 'Explore Further',
  'application.related.arrowLabel': 'Learn more',

  // footer
  'application.footer.lastUpdated': 'Last updated: 13 June 2026',
  'application.backToTop.ariaLabel': 'Back to top',

  // applicationHero
  'application.hero.title': 'Eligibility & Application Process',
  'application.hero.lead': 'Here is a guide to the eligibility requirements for Japan Butler Academy and the step-by-step process from application to enrollment confirmation.',

  // requirements
  'application.req.0.label': 'Age',
  'application.req.0.value': 'Age 18 or above (high school students may not apply)',
  'application.req.1.label': 'Nationality, Gender & Experience',
  'application.req.1.value': 'Open to all nationalities, genders, and experience levels. Beginners are warmly welcomed.',
  'application.req.2.label': 'Language',
  'application.req.2.value': 'Classes are conducted in Japanese. Participants must be able to follow instruction in Japanese.',
  'application.req.3.label': 'Physical Requirements',
  'application.req.3.value': 'Participants must be able to take part in practical sessions that involve standing for extended periods.',
  'application.req.4.label': 'Agreement to Terms',
  'application.req.4.value': 'Participants must agree to our enrolment terms and dress code.',

  // dressCode
  'application.dress.title': 'Dress Code for Classes',
  'application.dress.lead': 'Dress during class is an important element in developing the movement and bearing of a butler. Full details will be provided at your first class. White gloves are supplied by the academy on day one.',
  'application.dress.item.0.name': 'White Shirt',
  'application.dress.item.0.desc': 'A plain white shirt (long sleeves recommended). Please ensure it is clean and well-pressed.',
  'application.dress.item.1.name': 'Black Trousers or Skirt',
  'application.dress.item.1.desc': 'Black or charcoal-grey trousers or skirt with a clean silhouette.',
  'application.dress.item.2.name': 'Leather Shoes',
  'application.dress.item.2.desc': 'Black leather shoes (lace-ups or loafers). Choose a stable pair suitable for extended practicum sessions.',
  'application.dress.item.3.name': 'White Gloves (provided)',
  'application.dress.item.3.desc': 'High-quality white gloves are provided on day one. They are worn throughout practicum sessions.',
  'application.dress.imageAlt': 'A trainee wearing the required class attire: white shirt, black trousers, and white gloves',

  // applicationSteps
  'application.step.0.title': 'Request Brochure',
  'application.step.0.desc': 'Start with a free brochure for a comprehensive overview of our courses and the academy\'s educational philosophy.',
  'application.step.1.title': 'Individual Consultation',
  'application.step.1.desc': 'Our experienced staff will help you find the right course. Online consultations are available.',
  'application.step.2.title': 'Submit Application Form',
  'application.step.2.desc': 'Once you have decided on your course, please complete and submit the online application form.',
  'application.step.2.instruction': 'Go to Application Form',
  'application.step.3.title': 'Enrollment Contract',
  'application.step.3.desc': 'After your application, we will send the enrollment agreement by email. Please review it carefully and complete the contract procedure.',
  'application.step.3.instruction': 'Please check your email',
  'application.step.4.title': 'Bank Transfer',
  'application.step.4.desc': 'Please transfer the course fee in full by bank transfer no later than 14 days before the start date. Instalment plans and credit card payments are not accepted.',
  'application.step.4.instruction': 'Please transfer by 14 days before the start date',
  'application.step.5.title': 'Enrollment Confirmation',
  'application.step.5.desc': 'Once payment is confirmed, we will send your enrollment confirmation together with information on what to bring, your first class details, and access instructions.',
  'application.step.5.instruction': 'Please await your confirmation notice',
  'application.step.6.title': 'Course Begins',
  'application.step.6.desc': 'Your course begins! Day one starts gently with an orientation and the fundamentals of practical training.',

  // deadlineInfo
  'application.deadline.title': 'Application Deadline & Capacity',
  'application.deadline.lead': 'All courses are allocated on a first-come, first-served basis. Once capacity is reached, applications will be closed. If you are considering enrolment, we encourage you to apply early.',
  'application.deadline.item.0.label': 'Capacity',
  'application.deadline.item.0.value': '6 places per course (first come, first served)',
  'application.deadline.item.1.label': 'Application Deadline',
  'application.deadline.item.1.value': '14 days before each course start date',
  'application.deadline.item.2.label': 'Minimum Enrolment',
  'application.deadline.item.2.value': '3 students',
  'application.deadline.item.3.label': 'If minimum is not reached',
  'application.deadline.item.3.value': 'A full refund of the course fee will be issued, or the fee may be transferred to the next cohort with a 5% discount.',

  // paymentInfo
  'application.payment.title': 'Payment Details',
  'application.payment.lead': 'Course fee payment is by bank transfer (lump-sum) only. Full payment instructions will be provided in the enrollment agreement.',
  'application.payment.item.0.label': 'Payment Method',
  'application.payment.item.0.value': 'Bank transfer (lump-sum only). Instalment plans and credit card payments are not accepted.',
  'application.payment.item.1.label': 'Payment Deadline',
  'application.payment.item.1.value': 'Please transfer no later than 14 days before the course start date.',
  'application.payment.item.2.label': 'Transfer Fees',
  'application.payment.item.2.value': 'Bank transfer fees are the responsibility of the applicant.',
  'application.payment.item.3.label': 'Lateral Enrollment Discount',
  'application.payment.item.3.value': 'Graduates of a lower course may declare their completion certificate number at the time of application to receive the lateral enrollment discount.',

  // applicationFaqs
  'application.faq.0.q': 'Are there any eligibility requirements?',
  'application.faq.0.a': 'Applicants must be aged 18 or above and be able to follow instruction in Japanese. All nationalities, genders, and experience levels are welcome.',
  'application.faq.1.q': 'How do I apply?',
  'application.faq.1.a': 'After submitting the application form, we will send the enrollment agreement by email. Enrollment is confirmed once the course fee has been received.',
  'application.faq.2.q': 'When is the application deadline?',
  'application.faq.2.a': '14 days before each course start date. Applications close when the 6-place capacity is reached.',

  // applicationRelatedPages
  'application.related.0.title': 'Application Form',
  'application.related.0.desc': 'Apply for a main course',
  'application.related.1.title': 'Book a Consultation',
  'application.related.1.desc': 'Free, online-available consultation',
  'application.related.2.title': 'Admission Guide',
  'application.related.2.desc': 'Overview of the admission process',
  'application.related.3.title': 'Annual Schedule',
  'application.related.3.desc': 'Course start dates and class timetable',
};

export default application;
